import React, { useState, useEffect, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import { LuCalendarDays } from 'react-icons/lu';
import Card from 'react-bootstrap/Card';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import LanguageContext, { strings } from '../../contexts/language';
import api from '../../services/api';

import Base from '../../assets/images/base-square.png';

export default function Panel() {
    const { language } = useContext(LanguageContext);
    const t = strings[language] || strings.pt;
    const { url } = useParams();
    const [panels, setPanels] = useState([]);
    const [post, setPost] = useState(null);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!url) {
            api.post('/panels').then(r => {
                setPanels(r.data.content || []);
                setLoading(false);
            }).catch(() => setLoading(false));
        } else {
            api.post(`/post?url=${url}`).then(r => {
                const news = r.data.content?.[0];
                setPost(news);
                setItems(news?.post_items || []);
                setLoading(false);
            }).catch(() => setLoading(false));
        }
    }, [url]);

    if (loading) return <div className="page"><Header /><div className="loader-page"><div className="bt-spinner"></div></div><Footer /></div>;

    if (url && post) {
        return (
            <div className="page">
                <Header />
                <main style={{ flex: 1, padding: '40px 20px' }}>
                    <div style={{ maxWidth: 800, margin: '0 auto' }}>
                        <h2 className="section-title color_2 text-center">{language === 'en' ? post.title_en : post.title}</h2>
                        {items.map((item, i) => (
                            <div key={i} className="mb-20">
                                {item.type === 'image' && <img src={item.image} alt="" style={{ maxWidth: '100%', borderRadius: 12 }} />}
                                {item.type === 'text' && <div className="news-text" dangerouslySetInnerHTML={{ __html: language === 'en' ? item.text_en : item.text }} />}
                                {item.type === 'video' && (
                                    <div className="video-container">
                                        <iframe src={item.video_type === 'vimeo' ? `https://player.vimeo.com/video/${item.video}` : `https://www.youtube.com/embed/${item.video}?rel=0`} frameBorder="0" allowFullScreen title="video" />
                                    </div>
                                )}
                                {item.type === 'pdf' && (
                                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js">
                                        <Viewer fileUrl={language === 'en' ? item.file_en : item.file} defaultScale="PageWidth" />
                                    </Worker>
                                )}
                            </div>
                        ))}
                    </div>
                </main>
                <Footer />
            </div>
        );
    }

    return (
        <div className="page">
            <Header />
            <main style={{ flex: 1, padding: '40px 20px' }}>
                <div style={{ maxWidth: 1100, margin: '0 auto' }}>
                    <h2 className="section-title color_2 text-center">{t.panelists_title}</h2>
                    {panels.length === 0
                        ? <p className="text text-center">{language === 'en' ? 'COMING SOON' : 'EM BREVE'}</p>
                        : (
                            <div className="row g-4">
                                {panels.map(p => (
                                    <div key={p.id} className="col-12 col-sm-6 col-lg-4">
                                        <div className="panelist-card">
                                            <img src={Base} className="card-img-top" style={{backgroundImage: `url(${p.image})`}} />
                                            <div className="panelist-info">
                                                <div className="panelist-name">{p.title}</div>
                                                <div className="panelist-org">{language === 'en' ? p.description_en : p.description}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )
                    }
                </div>
            </main>
            <Footer />
        </div>
    );
}
